<div class="exception-container">
  <div class="exception-content">
    <h1 class="exception-code">{{ errorCode }}</h1>
    <h2 class="exception-message">{{ errorMessage }}</h2>
    <p class="exception-help-text">{{ errorHelpText }}</p>
    <p class="exception-navigation">
      You can return to your <a routerLink="/businessProcess" class="dashboard-link">Dashboard</a>.
    </p>
  </div>
</div>